import api from 'api'
import { CACHE_TAG_WORK_ORDER_STATUS_HISTORY } from 'api/cacheTagTypes'
import { withIdTag } from 'utils/cache'

import type { WorkOrderStatusEventListApi } from 'types/api/work-order/workOrderStatus'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getWorkOrderStatusHistory: builder.query<WorkOrderStatusEventListApi, { workOrderId: string }>({
      query: ({ workOrderId }) => ({ url: `/api/v1/core/work-orders/${workOrderId}/status/history` }),
      providesTags: (result, error, arg) => withIdTag(CACHE_TAG_WORK_ORDER_STATUS_HISTORY, arg?.workOrderId),
    }),
  }),
})

export const { useGetWorkOrderStatusHistoryQuery, useLazyGetWorkOrderStatusHistoryQuery } = extendedApi
